<template>
  <div class="container">
    <div class="shop_top no_nav">
      <custom-head :title="lang.title" :nav_show="false" />
    </div>
    <div v-if="info.orderno" class="width_center_1200">
      <div class="order-status" :class="info.hdtype === 11 ? 'card' : ''">
        <template v-if="info.hdtype === 11">
          <div>
            {{ $t('order_detail').card_num1 }}：<span>{{ info.goodstotalnum }}</span>
          </div>
          <div>
            {{ $t('order_detail').card_num2 }}：<span>{{ info.synum }}</span>
          </div>
          <div>
            {{ $t('card').validity }}：<span>{{ info.xmcardenddate }}</span>
          </div>
        </template>
        <template v-else>
          {{ lang.order_status }}：
          <span v-if="info.states === 0">{{ lang.status_text1 }}</span>
          <span v-if="info.states === 1">{{ lang.status_text2 }}</span>
          <span v-if="info.states === 2">{{ lang.status_text3 }}</span>
          <span v-if="info.states === 3">{{ lang.status_text4 }}</span>
          <span v-if="info.states === 4">{{ lang.status_text5 }}</span>
          <span v-if="info.states === 5">{{ lang.status_text6 }}</span>
        </template>
      </div>
      <div v-if="info.hdtype === 11 && machineList.length" class="order-content">
        <div class="self-mention self-mention-select">
          <el-image :src="machineList[machineIndex].vemimg" fit="cover" lazy></el-image>
          <div class="cont">
            <div class="name">{{ machineList[machineIndex].vemName }}</div>
            <div class="vemid">{{ lang.vemid }}：{{ machineList[machineIndex].vemId }}</div>
          </div>
          <div class="right">
            <div class="address">{{ machineList[machineIndex].vemaddress }}</div>
            <div class="distance">
              <svg-icon iconClass="location" />
              {{ lang.distance }}：{{ machineList[machineIndex].distance }}{{ machineList[machineIndex].distanceunit }}
            </div>
            <div class="select" @click="changeMachine">
              {{ $t('order_detail').card_change }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="order-content">
        <div class="self-mention">
          <el-image :src="info.hdtype === 11 ? info.xmcardimg : info.vedinfo.vemimg" fit="cover" lazy></el-image>
          <div class="cont" @click="info.hdtype !== 11 && $router.push(info.vedinfo.ptype === 1 ? `/machine/index?vemId=${info.vedinfo.vemId}` : `/coffee/index?vemId=${info.vedinfo.vemId}`)">
            <div class="name">{{ info.hdtype === 11 ? info.xmcardname : info.vedinfo.vemName }}</div>
            <div v-if="info.hdtype !== 11" class="vemid">{{ lang.vemid }}：{{ info.vedinfo.vemId }}</div>
          </div>
          <div v-if="info.hdtype !== 11" class="right">
            <div class="address">{{ info.vedinfo.vemaddress }}</div>
            <div class="distance">
              <svg-icon iconClass="location" />
              {{ lang.distance }}：{{ info.vedinfo.distance }}{{ info.vedinfo.distanceunit }}
            </div>
          </div>
        </div>
        <div class="goods-info">
          <div class="title">{{ lang.goods_list }}</div>
          <ul
            :class="showGoods ? 'show' : ''"
            :style="{maxHeight: showGoods ? goodsHeight : '333px'}"
          >
            <li v-for="item in info.orderitem" :key="item.id">
              <el-image
                :src="item.productimg"
                lazy
                @click.stop="$router.push(`/goods/info/${item.productno}`)"
              ></el-image>
              <div class="cont">
                <div
                  class="name"
                  @click.stop="$router.push(`/goods/info/${item.productno}`)"
                >{{ item.productname }}</div>
                <div class="desc">{{ item.briefName }}</div>
                <div class="bottom">
                  <div v-if="item.integral > 0" class="price">
                    MOP
                    <span>{{ item.productprice.toFixed(2) }}</span> + <span>{{ item.integral }}{{ lang.integral }}</span>
                  </div>
                  <div v-else class="price">
                    <template v-if="info.hdtype === 11">{{ $t('card').value }}</template>MOP
                    <span>{{ item.productprice.toFixed(2) }}</span>
                  </div>
                  <div v-if="info.hdtype !== 11" class="num">x{{ item.productnum }}</div>
                </div>
              </div>
              <div
                v-if="info.hdtype === 11 || item.refundstatus === -1 && info.orderptype === 3 && info.states === 1 || item.refundstatus === -1 && info.orderptype === 3 && info.states === 2"
                class="code"
                @click="getGoodsCode(item)"
              >
                <svg-icon iconClass="code" />
                <span>{{ lang.redemption_code }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="code-endtime">
                <span v-if="item.refundstatus > 0">{{ item.refundstatustext }}</span>
                <span v-if="item.deliverStatustime">{{ lang.has_been }}{{ item.deliverStatustime }}{{ lang.exchange }}</span>
              </div>
            </li>
          </ul>
          <div v-if="info.orderitem.length > 3" class="toggle-box" @click="showGoods =! showGoods">
            {{ showGoods ? lang.putaway : lang.expand }}
            <i
              :class="showGoods ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            />
          </div>
        </div>
        <ul class="pay-info">
          <li v-if="info.givestype && info.givephoneorder">{{ lang.send_friend }}：{{ info.givephoneorder }}</li>
          <div v-if="info.orderptype === 4 && info.pickupCode" class="code-box order-code-box">
            <div class="tip">{{ lang.code_text1 }}</div>
            <div class="tip">{{ lang.code_text2 }}</div>
            <div class="title">{{ lang.code_text3 }}</div>
            <div class="num">{{ info.pickupCode }}</div>
          </div>
          <li>{{ lang.order_status }}：{{ info.statestext }}</li>
          <li>{{ lang.payment_method }}：{{ info.paytype }}</li>
          <li>{{ lang.delivery_method }}：{{ info.ispeisong ? lang.home_delivery : lang.pickup }}</li>
          <li>{{ lang.orderno }}：{{ info.orderno }}</li>
          <li>{{ lang.orderno_time }}：{{ info.addtime }}</li>
          <li v-if="info.paytime">{{ lang.pay_time }}：{{ info.paytime }}</li>
          <li v-if="info.refundstatus > 0">{{ lang.refund_status_text }}：{{ info.refundstatustext }}</li>
          <li v-if="info.refundstatus === 1">{{ lang.refund_pay_text }}：{{ info.refundpaytext }}</li>
          <li v-if="info.refundstatus >= 0">{{ lang.refund_amount }}：{{ info.refundmoney }}</li>
        </ul>
        <div class="order-info">
          <ul>
            <li>
              <div class="name">{{ lang.amount }}</div>
              <div v-if="info.totalmoney" class="value">
                <span>MOP</span>
                {{ info.totalmoney.toFixed(2) }}
              </div>
            </li>
            <li v-if="info.hdtype === 1">
              <div class="name">{{ lang.point }}</div>
              <div class="value">
                {{ info.paypoint }}
              </div>
            </li>
            <li v-if="info.discountmoney > 0">
              <div class="name">{{ lang.coupon }}</div>
              <div class="value">
                <span>-MOP</span>
                {{ info.discountmoney }}
              </div>
            </li>
            <li v-if="info.paypoint > 0">
              <div class="name">{{ lang.paypoint }}</div>
              <div class="value">
                {{ info.paypoint }}
              </div>
            </li>
          </ul>
          <div v-if="info.hdtype !== 1" class="total-pay">
            <div class="tit">{{ lang.payable }}：</div>MOP
            <span>{{ info.totalpaymoney.toFixed(2) }}</span> 
            <template v-if="info.paypoint">
            &nbsp;+<span>{{ info.paypoint }}{{ lang.integral }}</span>
            </template>
          </div>
        </div>
      </div>
      <div v-if="info.hdtype !== 1" class="order-bottom">
        <div class="total-box">
          <div class="name">{{ lang.total }}：</div>
          <div class="money">
            MOP
            <span>{{ info.totalpaymoney.toFixed(2) }}</span>
            <template v-if="info.paypoint">
            + <span>{{ info.paypoint }}{{ lang.integral }}</span>
            </template>
          </div>
        </div>
        <div class="action-btns">
          <div
            v-if="info.states === 0"
            class="item-btn cancel"
            @click="handleCancel"
          >{{ lang.cancel_order }}</div>
          <!-- <div
            v-if="info.states >= 1 && info.states <= 2"
            class="item-btn"
            @click="handleRefund"
          >申请退款</div>-->
          <div v-if="info.states === 0" class="item-btn" @click="handlePay">{{ lang.settle }}</div>
        </div>
      </div>
    </div>
    <el-empty v-if="errMsg" :description="errMsg"></el-empty>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
    <!-- 兑换码 -->
    <el-dialog :visible.sync="codeData.show" width="280px" class="code-box">
      <div v-loading="codeData.loading">
        <div class="tip">{{ lang.code_text1 }}</div>
        <div class="tip">{{ lang.code_text4 }}</div>
        <div class="title">{{ lang.code_text3 }}</div>
        <div class="num">{{ codeData.code }}</div>
      </div>
    </el-dialog>
    <el-dialog
      class="pay-dialog"
      :visible.sync="showPayDialog"
      :close-on-click-modal="false"
      width="30%"
    >
      <i class="el-icon-loading" />
      <div class="loading-text">{{ lang.payments }}</div>
      <div
        class="btn"
        @click="showPayDialog = false, init()"
      >{{ lang.close }}</div>
    </el-dialog>
    <!-- 支付选择弹窗 -->
    <PayDialog ref="payDialog"></PayDialog>
    <!-- 选择机器 -->
		<machine-dialog ref="machineDialog" @update="getInfo(info.orderno)" @confirm="confirmMachine" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomHead from '@/components/CustomHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { getbocpaylist } from '@/api/home'
import PayDialog from '@/components/PayDialog/index.vue'
import { getqueryorderstate } from '@/api/orderuser.js'
import {
  getorderetail,
  cancelpayorder,
  refundpayorder,
  getorderitemcode,
  getcardorderitem
} from '@/api/orderuser.js'
import { getvendingmachinelist } from '@/api/vendingmachine'
import MachineDialog from '@/components/MachineDialog'
export default {
  components: {
    CustomHead,
    ShopFoot,
    PayDialog,
    MachineDialog
  },
  data() {
    return {
      info: {
        orderitem: []
      },
      errMsg: '',
      showGoods: false,
      codeData: {
        loading: false,
        show: false,
        code: ''
      },
      showPayDialog: false,
      timer: '',
      machineList: [],
      machineIndex: 0
    }
  },
  computed: {
    lang() {
      return this.$t('order_detail')
    },
    orderno() {
      return this.$route.query.orderno
    },
    goodsHeight() {
      return this.info.orderitem.length * 111 + 'px'
    },
    ...mapGetters(['location'])
  },
  created() {
    this.init()
  },
  methods: {
    async init(loading = false) {
      try {
        const { data } = await getorderetail({
          orderno: this.orderno,
          ...this.location
        }, loading)
        if (!data) {
          this.errMsg = this.lang.not_order
          this.info = {}
          return
        }
        this.info = data
        if (data.hdtype === 11) {
          this.getMachineList(data.hxvemIds)
        }
        if (!loading) {
          this.getPayList(data.paytype)
        }
      } catch (err) {
        this.errMsg = err.msg
      }
    },
    async getMachineList(hxvemIds) {
      const { data } = await getvendingmachinelist({
        orderkey: -1, // 排序：-1 默认 ，0 由远到近 1由近到远
        areaid: 0,
        ptype: 2, // 0 全部 1 售货机 2咖啡机
        hxvemIds,
        ...this.location
      })
      this.machineList = data
      this.getCardOrderItem(data[0].vemId)
    },
    async getCardOrderItem(vemId) {
      const { data } = await getcardorderitem({
        orderno: this.info.orderno,
        vemId
      })
      this.$set(this.info, 'orderitem', data)
    },
    // 获取兑换码
    getGoodsCode(item) {
      if (this.info.hdtype === 11) {
        this.$refs.machineDialog.getCode(item.id, this.machineList[this.machineIndex].vemId)
        return
      }
      this.codeData.loading = true
      getorderitemcode({ orderitemid: item.id }).then(({ data }) => {
        this.codeData.loading = false
        if (data) {
          this.codeData.show = true
          this.codeData.code = data.pickupCode
        }
      })
    },
    getPayList(paytype) {
      getbocpaylist({
        platform: this.$platform
      }).then(({ data }) => {
        data.forEach((item) => {
          if (item.paytype === paytype) {
            this.info.paytype = item.payname
            return
          }
        })
      })
    },
    handleCancel() {
      this.$confirm(this.lang.cancel_tips, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        cancelpayorder({ orderno: this.info.orderno }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.init()
          }
        })
      })
    },
    handleRefund() {
      this.$confirm(this.lang.refund_tips, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        refundpayorder({ orderno: this.info.orderno }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.init()
          }
        })
      })
    },
    async handlePay() {
      this.$refs.payDialog.showDialog(this.info.orderno)
    },
    getPayState(orderno) {
      getqueryorderstate({
        orderno: orderno
      }).then(({ data }) => {
        if (data.ispay === 1) {
          clearInterval(this.timer)
          this.$router.push(`/order/detail?orderno=${orderno}`)
        }
      })
    },
    changeMachine() {
      this.$refs.machineDialog.init(this.machineList, this.machineIndex)
    },
    confirmMachine(index) {
      this.machineIndex = index
      this.getCardOrderItem(this.machineList[index].vemId)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #fff;
}
.order-status {
  min-height: 60px;
  line-height: 60px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px #f1f4f9;
  color: #000000;
  font-size: 14px;
  padding: 0 20px;
  margin-bottom: 20px;
  &.card {
    line-height: 40px;
    padding: 20px;
  }
}
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  &.cur {
    background: #ec9221;
  }
}
.order-content {
  margin-bottom: 15px;
  border: 1px solid #eeeeee;
  padding: 15px;
  .title {
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .self-mention {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    &.self-mention-select {
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
      cursor: pointer;
    }
    .el-image {
      width: 68px;
      height: 40px;
      border-radius: 4px;
    }
    .cont {
      cursor: pointer;
      flex: 1;
      margin-left: 15px;
      .name {
        color: #000;
        font-size: 14px;
      }
      .vemid {
        color: #999;
        font-size: 12px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .address,
      .distance {
        display: flex;
        align-items: center;
        color: #000;
        font-size: 14px;
        margin-left: 30px;
        .svg-icon {
          width: 16px;
          margin-right: 8rpx;
        }
      }
      .select {
        margin-left: 20px;
      }
    }
  }
  .receiver-box {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    .text {
      padding-bottom: 24px;
      span {
        color: #4f4f4f;
        font-size: 12px;
        padding-right: 20px;
      }
    }
  }
  .goods-info {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 40px;
    ul {
      position: relative;
      z-index: 99;
      padding: 10px;
      max-height: 333px;
      overflow: hidden;
      transition: all 0.3s;
      &.show {
        transition: all 0.3s;
      }
      li {
        position: relative;
        display: flex;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        &:last-child {
          border-bottom: 0;
        }
        .code {
          position: absolute;
          top: 15px;
          right: 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 12px;
            color: #000;
            padding: 0 6px;
          }
        }
        .code-endtime {
          position: absolute;
          top: 46px;
          right: 10px;
          color: #ff0000;
          font-size: 12px;
        }
        .el-image {
          width: 80px;
          height: 80px;
          margin-right: 15px;
          cursor: pointer;
        }
        .cont {
          flex: 1;
          position: relative;
          .name {
            color: #000;
            font-size: 14px;
            padding-bottom: 8px;
            cursor: pointer;
          }
          .desc {
            color: #4f4f4f;
            font-size: 12px;
          }
          .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            .price {
              color: #ff0000;
              font-size: 12px;
              span {
                font-size: 14px;
                padding-left: 5px;
                font-weight: 700;
              }
            }
            .num {
              font-size: 12px;
              color: #000;
            }
          }
        }
      }
    }
    .toggle-box {
      position: relative;
      z-index: 100;
      background: #fff;
      margin-top: -12px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      font-size: 14px;
      color: #4f4f4f;
      cursor: pointer;
      i {
        margin-left: 4px;
        font-size: 18px;
      }
    }
  }
  .pay-info {
    padding-bottom: 20px;
    margin-bottom: 45px;
    border-bottom: 1px solid #eeeeee;
    li {
      font-size: 14px;
      color: #4f4f4f;
      padding-bottom: 10px;
    }
  }
  .order-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    ul {
      width: 315px;
      border-bottom: 1px solid #eeeeee;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #4f4f4f;
        font-size: 14px;
        padding-bottom: 12px;
        span {
          font-size: 12px;
          padding-right: 4px;
        }
      }
    }
    .total-pay {
      width: 100%;
      padding: 15px 0 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .tit {
        font-size: 14px;
        color: #4f4f4f;
      }
      color: #ff0000;
      font-size: 12px;
      span {
        font-weight: bold;
        font-size: 16px;
        padding-left: 4px;
      }
    }
  }
}
.order-bottom {
  padding-bottom: 108px;
  .total-box {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #ec9221;
    .name {
      color: #000;
      font-size: 14px;
    }
    .money {
      color: #ff0000;
      font-size: 14px;
      padding-left: 2px;
      span {
        padding-left: 5px;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
  .action-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item-btn {
      text-align: center;
      width: 145px;
      height: 40px;
      line-height: 40px;
      background: #ec9221;
      border: 1px solid #ec9221;
      border-top: 0;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      cursor: pointer;
      margin-left: 4px;
      &.cancel {
        background: #ffffff;
        color: #4f4f4f;
        font-size: 14px;
      }
    }
  }
}
/deep/ .code-box {
  display: flex;
  align-items: center;
  justify-content: center;
  &.order-code-box {
    flex: 1;
    flex-direction: column;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 40px;
    margin-bottom: 30px;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  text-align: center;
  .tip {
    color: #ff0000;
    font-size: 15px;
  }
  .title {
    color: #ff0000;
    font-size: 20px;
    padding: 20px 0 10px;
  }
  .num {
    font-weight: bold;
    color: #ff0000;
    font-size: 20px;
    letter-spacing: 6px;
  }
}
.pay-dialog {
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  i {
    font-size: 60px;
    font-weight: bold;
    color: #ec9221;
  }
  .loading-text {
    color: #aaa;
    font-size: 14px;
    padding: 10px 0 20px;
  }
  .btn {
    cursor: pointer;
    width: 120px;
    height: 38px;
    line-height: 38px;
    margin: 0 auto;
    background: #ec9221;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
  }
}
</style>